<div class="warning-alert">
    <div class="alert-card">
        <img src="./../../assets/warning.png" alt="warning icon">
        <p>Unknown location</p>
    </div>
</div>
